// ##### Komarov 2025-08-26
import { isDeveloperMode } from './isDeveloperLogin';
import { isServer } from '../../server/helpers/browserDetector';

export const getDev = (cookieStringOptional) => {
  if (isServer) {
    try {
      const cookieString = typeof cookieStringOptional === 'string'
        ? cookieStringOptional
        : (typeof global !== 'undefined' ? (global.__cookieString || '') : '');
      return isDeveloperMode({ cookieString });
    } catch {
      return false;
    }
  }
  return isDeveloperMode();
};

export default getDev;


